/**
 * Consise function generator used with classNames objects.
 */
const setClassSuffix = base => {
  return suffix => `${base}${suffix}`;
};

export default setClassSuffix;
